import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { StoreService } from 'src/app/store/store/store.service';
import { StorageService } from 'src/app/shared/services/storage.service';

@Component({
  selector: 'app-payment-failed',
  templateUrl: './payment-failed.component.html',
  styleUrls: ['./payment-failed.component.scss']
})
export class PaymentFailedComponent implements OnInit {

  payTranId: string = '';
  isFailed: boolean = false;
  isApp: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private navigationService: NavigationService,
    private previousRouteService: PreviousRouteService,
    private storeService: StoreService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.payTranId = params['PayTranId'] ? params['PayTranId'] : '';
      this.isFailed = params['IsSuccess'] === 'False' ? true : false;
      this.isApp = params['IsApp'] === 'True' ? true : false;

      if (this.isFailed && this.isApp) {
        this.location.replaceState('/payment-failed/' + this.payTranId);
      } else if (this.isFailed) {
        try {
          this.storageService.removeForceCheckoutFlag();
          let paymentBackRoute = this.previousRouteService.getPaymentBackUrl();
          let storeBackRoute = this.previousRouteService.getCartBackUrl();
          if (paymentBackRoute) {
            this.navigationService.navigateByUrl(paymentBackRoute);
          } else if (!paymentBackRoute && storeBackRoute) {
            this.navigationService.navigateByUrl(storeBackRoute);
          } else {
            this.backToStoreOrHome();
          }
        } catch (e) {
          console.log("Payment Failed", e)
        }

      } else {
        this.backToStoreOrHome();
      }
    });
  }

  async backToStoreOrHome() {
    let fromStorePageData = this.previousRouteService.getFromStoreFlag();
    if (fromStorePageData && fromStorePageData?.storeId) {
      let locDescWithoutSpaces = await this.storeService.replaceWhiteSpaceWithDash(fromStorePageData.storeTag);
      this.navigationService.navigate(['store', fromStorePageData.storeId, locDescWithoutSpaces], { replaceUrl: true });
      this.previousRouteService.removeIsFromStoreFlag();
    }
    else {
      this.navigationService.navigate(['home']);
    }
  }
}
